import { render, staticRenderFns } from "./ModalImageReports.vue?vue&type=template&id=6385bef6&scoped=true&lang=pug"
import script from "./ModalImageReports.vue?vue&type=script&lang=js"
export * from "./ModalImageReports.vue?vue&type=script&lang=js"
import style0 from "./ModalImageReports.vue?vue&type=style&index=0&id=6385bef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6385bef6",
  null
  
)

export default component.exports